<template>
  <div class="pages">
    <!--    导航-->
    <shortcut></shortcut>
    <!--    头部-->
    <commonHeader :selectCode="3"></commonHeader>
    <!--    内容-->
    <div class="content">
      <div class="title">
        <img src="../../assets/img/title.png"
             alt="">
        <span>{{$t('领券立减')}}</span>
        <img src="../../assets/img/title.png"
             alt="">
      </div>
      <div class="volume">
        <el-row :gutter="20">
          <el-col :span="8"
                  v-for="(v,i) in brandList"
                  :key="i">
            <div class="volume_">
              <div class="volume-left">
                <div class="top"><span>{{"<"+v.type_text+'>'}}{{ v.name }}</span></div>
                <div class="bottom">
                  <div class="sum"
                       v-if="v.type=='discount'">
                    <span class="nu">{{v.discount }}</span>
                    <span>{{$t('折')}}</span>
                  </div>
                  <div class="sum"
                       v-if="v.type=='reduction'">
                    <span>¥</span>
                    <span class="nu">{{Number.parseInt(v.price) }}</span>
                  </div>
                  <div class="sum"
                       v-if="v.type=='shipping'">
                    <span>{{$t('免邮费')}}</span>
                  </div>
                  <div class="sum-limit">
                    <p>{{$t('满')}}{{ Number.parseInt(v.limit)}}{{$t('元可用')}}</p>
                    <span>{{$t('还剩下')}}{{v.surplus}}{{$t('张')}}</span>
                  </div>
                </div>
              </div>
              <div @click="getCoupon(v.id)"
                   class="volume-text">
                <span>{{$t('立即领取')}}</span>
              </div>
            </div>
          </el-col>
        </el-row>
        <div style="margin-top: 50px;text-align: right;">
          <el-pagination background
                         :page-size="per_page"
                         @current-change="goPage"
                         layout="prev, pager, next,jumper"
                         :total=total>
          </el-pagination>
        </div>
      </div>

    </div>
    <!--    底部-->
    <foot style="padding-top: 15px;"></foot>

  </div>
</template>


<script>
import shortcut from '@/components/shortcut/shortcut.vue';
import foot from '@/components/footer/footer.vue';

export default {

  components: {
    shortcut,
    foot
  },
  data () {
    return {
      block1: false,
      block2: false,
      brandList: [],
      total: 1,
      per_page: 15
    }
  },
  mounted () {
    this.getInit()
  },
  computed: {},
  beforeDestroy () {

  },
  methods: {
    getCoupon (id) {
      let that = this
      this.$jx.IsToken().then((res) => {
        if (res) {
          that.$http.post("/wanlshop/coupon/receive", {
            id: id,
          }).then(res => {
            if (res.code == 1) {
              that.$message({
                message: res.data.msg,
                type: 'success'
              });
            } else {
              that.$message(res.msg);
            }
          },
            err => {
            })
        } else {
          this.$router.push({ path: '/login/signIn' });
        }
      })
    },
    goPage (val) {
      this.getSelf(val)
      this.$nextTick(() => {
        window.scroll(0, 0);
      })
    },
    getInit () {
      this.getSelf('1')
    },
    getSelf (page) {
      this.$http.get("/wanlshop/coupon/getList", {
        page: page
      }).then(res => {
        this.brandList = res.data.data
        this.total = res.data.total
        this.per_page = res.data.per_page
      },
        err => {
        })
    },
    more (block) {
      this[block] = !this[block]
    }
  },
};

</script>


<style scoped lang="scss">
@import "../../assets/css/volume";
</style>



// WEBPACK FOOTER //
// src/views/volume/index.vue